<script context="module">
    export const name = "line";
</script>

<script lang="ts">
    import { getContext } from "svelte";
    import Data from "@reperio-news/core.components/blocks/ContentItem/Data";
    import { stripTags } from "@reperio-news/core.components/includes/Helpers";
    import { z } from "zod";
    type Data = z.infer<typeof Data>;
    import { slugToColor } from "../TopMenu/View.svelte";

    const context: SvelteStore<any> = getContext("context");
    export let data: Data;

    const contextColor = slugToColor(
        data.content.category?.slug,
        $context.global_blocks?.TopMenu_main_menu.data?.items
    );
</script>

{#if data && data.content}
    <a
        class="line-item"
        href={data.content.url}
        style="--color: {contextColor}"
    >
        <span class="round" />
        {stripTags(data.content.title)}
    </a>
{/if}

<style lang="scss">
    .line-item {
        width: calc(100% - 20px);
        font-size: 18px;
        font-weight: normal;
        line-height: 28px;
        padding: 5px;
        margin-bottom: 5px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        text-overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        border-bottom: 1px dotted #ccc;

        .round {
            display: block;
            width: 10px;
            height: 10px;
            float: left;
            margin: 10px 10px 0 0;
            background-color: var(--color);
            border-radius: 100px;
        }
    }
</style>
